<template>
  <div ref="scratchParent">
    <div class="vue-scratchable-wrapper p-0 mb-0" v-if="!showCongrats && !showCongratsPreview">
        <slot :init="init"></slot>
        <canvas
          v-if="showScratch"
          @mousedown="mouseDown"
          @mousemove="mouseMove"
          @touchstart="touchDown"
          @touchmove="touchMove"
        />
        <div v-if="!isHalf && showScratch" class="loading-block"></div>
      </div>
    <div v-else class="congrats">
      <h2  :style="congrats_style"><strong>Congratulations!</strong></h2>
        <div class="congrats-icon">
          <img class="mx-auto" :src="image_url" />
        </div>
        <div v-if="headline" :style="congrats_style">
          <p style="text-align: center; color:#8a7018; font-weight: bold">TO CLAIM YOUR PRICE <br></p>
          <p style="margin-top: 15px">
            <strong>1 - {{headline}}</strong>
          </p>
        </div>
        <div class="confirmation-code">
          <h3 >Your Reward Code</h3>
          <h1 >CNF#: {{ code }}</h1>
        </div>
        <p  v-if="headline" :style="congrats_style"><strong>2 - Activate your reward code</strong></p>
        <p  v-if="headline" :style="congrats_style">To Activate Submit your E-mail address below or get a screenshot of your reward code</p>
        <div class="expire-date">
          <p  :style="congrats_style"><strong>You can use this code until:</strong> {{expires}}</p>
        </div>
      </div>

  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'VueScratchable',
  components: {
  },
  props: {
    loaded: {
      type: Function
    },
    showSocials: {
      type: Function
    },
    showScratch: {
      type: Boolean
    },
    showCongratsPreview: {
      type: Boolean,
      default: false
    },
    brushOptions: {
      type: Object,
      default: () => ({
        size: 30,
        shape: 'round'
      })
    },
    code: {
      type: String
    },
    expires: {
      type: String
    },
    image_url: {
      type: String
    },
    completed: {
      type: Function
    },
    showinfo: {
      type: Function
    },
    hideOptions: {
      type: Object,
      default: () => ({
        type: 'color',
        value: '#dadada'
      })
    },
    getPercentageCleared: {
      type: Boolean,
      default: false
    },
    percentageStride: {
      type: Number,
      default: 150
    },
    headline: {
      type: String,
      default: null
    }
  },
  computed: {
    congrats_style () {
      if (this.campaign_theme) {
        if (this.campaign_theme.congrats) {
          return `color: ${this.campaign_theme.congrats.color}; font-size: ${this.campaign_theme.congrats.size}px; font-weight: ${this.campaign_theme.congrats.weight};`
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    campaign_theme () {
      return this.$store.state.campaign_theme
    },
    scratch_sound () {
      return this.$store.state.audio
    }
  },
  watch: {
    campaign_theme () {},
    isPressed () {
      this.isHalf = true
      if (this.isPressed) {
        this.scratch_sound.play()
      } else {
        this.scratch_sound.pause()
      }
    }
  },
  data () {
    return {
      shouldShowScratch: false,
      scratchImg: require('@/assets/images/default_scratch_texture.jpg'),
      canvas: null,
      context: null,
      isPressed: false,
      offset: {
        top: 40,
        left: 40
      },
      position: {
        currX: 0,
        currY: 0,
        lastX: 0,
        lastY: 0
      },
      observer: null,
      initFlag: false,
      cx: 0,
      cy: 0,
      cw: 0,
      ch: 0,
      showCongrats: false,
      isCleared: false,
      isHalf: false
    }
  },
  mounted () {
    if (this.showScratch) {
      this.canvas = this.$el.querySelector('canvas')
      const debounceInit = debounce(() => this.init(), 200)

      this.observer = new MutationObserver((mutations) => {
        mutations.forEach(({attributeName}) => {
          if (this.initFlag || !attributeName) return
          debounceInit()
        })
      })
      this.observer.observe(this.$el, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
      })

      window.addEventListener('mouseup', this.mouseUp, false)
      window.addEventListener('touchend', this.touchUp, false)
      window.addEventListener('touchcancel', this.touchUp, false)

      this.init()

      window.addEventListener('resize', debounce(this.init, 500))
    }
    this.scratch_sound.loop = true
  },
  destroyed () {
    if (this.showScratch) {
      window.removeEventListener('mouseup', this.mouseUp)
      window.removeEventListener('touchend', this.touchUp)
      window.removeEventListener('touchcancel', this.touchUp)

      window.removeEventListener('resize', debounce(this.init, 500))

      this.observer.disconnect()
    }
    this.scratch_sound.pause()
  },
  methods: {
    init () {
      this.initFlag = true
      this.setCanvasSizeAndContext()
      this.$nextTick(() => this.fillArea())
    },
    setCanvasSizeAndContext () {
      this.$nextTick(() => {
        /*const width = window.innerWidth
        const height = window.innerHeight*/
        const {width, height} = this.$refs.scratchParent.getBoundingClientRect()
        console.log(width, height, 'canvas height')
        this.canvas.width = width
        this.canvas.height = height
        this.context = this.canvas.getContext('2d')
      })
    },

    setOffsets () {
      const {top, left} = this.canvas.getBoundingClientRect()
      this.offset.top = top + window.scrollY
      this.offset.left = left + window.scrollX
    },

    async fillArea () {
      const {width, height} = this.context.canvas
      await this.setFillStyle()
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(` Failed to load image!
            Error: ${err.name}
            Message: ${err.message}
          `)
        })
      this.context.fillRect(0, 0, width, height)
      this.initFlag = false
      this.loaded()
    },

    setFillStyle () {
      const {
        type,
        value = '',
        repeat = 'repeat',
        size = 'cover'
      } = this.hideOptions
      this.context.globalCompositeOperation = 'source-over'

      // eslint-disable-next-line no-return-assign
      if (type === 'color') return new Promise((resolve) => resolve(this.context.fillStyle = value))

      return new Promise((resolve, reject) => {
        const img = new Image()

        console.log('loaded img')
        //window.console.image(this.scratchImg)
        img.onload = () => {
          resolve(img)
          this.coverImg(img, size)

          this.context.fillStyle = this.context.createPattern(this.canvas, repeat)
        }
        img.onerror = (err) => reject(err)
        img.src = `${this.hideOptions.src}?${new Date().getTime()}`
        img.setAttribute('crossOrigin', '')

      })
    },
    coverImg (img, type) {
      const imgRatio = img.height / img.width
      const winRatio = this.canvas.height / this.canvas.width
      console.log('înfo', imgRatio, winRatio, type)
      if ((imgRatio <= winRatio && type === 'contain') || (imgRatio >= winRatio && type === 'cover')) {
        console.log('1')
        const h = this.canvas.width * imgRatio
        this.context.drawImage(img, 0, (this.canvas.height - h) / 2, this.canvas.width, h)
      } else if ((imgRatio >= winRatio && type === 'contain') || (imgRatio <= winRatio && type === 'cover')) {
        console.log('2')
        const w = this.canvas.width * winRatio / imgRatio
        this.context.drawImage(img, (this.canvas.width - w) / 2, 0, w, this.canvas.height)
      }
    },
    drawImageProp (ctx, img, x, y, w, h, offsetX, offsetY) {
      console.log('drawing image info', img)
      if (arguments.length === 2) {
        x = y = 0
        w = this.canvas.width
        h = this.canvas.height
      }

      // default offset is center
      offsetX = typeof offsetX === 'number' ? offsetX : 0.5
      offsetY = typeof offsetY === 'number' ? offsetY : 0.5

      // keep bounds [0.0, 1.0]
      if (offsetX < 0) offsetX = 0
      if (offsetY < 0) offsetY = 0
      if (offsetX > 1) offsetX = 1
      if (offsetY > 1) offsetY = 1

      const iw = img.width,
        ih = img.height,
        r = Math.min(w / iw, h / ih)
      let nw = iw * r   // new prop. width
      let nh = ih * r   // new prop. height
      let ar = 1

      // decide which gap to fill
      if (nw < w) ar = w / nw
      if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh  // updated
      nw *= ar
      nh *= ar

      // calc source rectangle
      this.cw = iw / (nw / w)
      this.ch = ih / (nh / h)

      this.cx = (iw - this.cw) * offsetX
      this.cy = (ih - this.ch) * offsetY

      // make sure source rectangle is valid
      if (this.cx < 0) this.cx = 0
      if (this.cy < 0) this.cy = 0
      if (this.cw > iw) this.cw = iw
      if (this.ch > ih) this.ch = ih

      // fill image in dest. rectangle
      ctx.drawImage(img, this.cx, this.cy, this.cw, this.ch,  x, y, w, h)
    },
    clearArea () {
      const {width, height} = this.context.canvas
      this.context.globalCompositeOperation = 'destination-out'
      this.context.fillRect(0, 0, width, height)
      this.showCongrats = true

      if (!this.isCleared) {
        this.isCleared = true
        this.completed()
        this.showSocials(true)
        this.scratch_sound.pause()
      }
    },

    draw () {
      const {
        currX,
        currY,
        lastX,
        lastY
      } = this.position
      this.context.beginPath()
      this.context.globalCompositeOperation = 'destination-out'
      this.context.lineWidth = this.brushOptions.size
      this.context.lineJoin = this.brushOptions.shape
      this.context.moveTo(lastX, lastY)
      if (this.isPressed) {
        this.context.lineTo(currX, currY)
      } else {
        this.context.lineTo(currX + 0.01, currY + 0.01)
      }
      this.context.closePath()
      this.context.stroke()
      this.lastPositionHelper(currX, currY)
      this.calculateClearedArea()
    },

    lastPositionHelper (x, y) {
      this.position.lastX = x
      this.position.lastY = y
    },
    currentPositionHelper (x, y) {
      this.position.currX = x - this.offset.left
      this.position.currY = y - this.offset.top
    },

    mouseDown ({clientX, clientY}) {
      this.setOffsets()
      this.currentPositionHelper(clientX, clientY)
      this.lastPositionHelper(this.position.currX, this.position.currY)
      this.draw()
      this.isPressed = true
    },
    mouseMove ({clientX, clientY}) {
      if (!this.isPressed) return
      this.currentPositionHelper(clientX, clientY)
      this.draw()
    },
    mouseUp () {
      this.isPressed = false
    },

    touchDown ({targetTouches: [{clientX, clientY}]}) {
      this.setOffsets()
      this.currentPositionHelper(clientX, clientY)
      this.lastPositionHelper(this.position.currX, this.position.currY)
      this.draw()
      this.isPressed = true
    },
    touchMove (event) {
      if (event.cancelable) {
        event.preventDefault()
      }
      const {targetTouches: [{clientX, clientY}]} = event
      this.currentPositionHelper(clientX, clientY)
      this.draw()
    },
    touchUp () {
      this.isPressed = false
    },

    calculateClearedArea () {
      if (!this.getPercentageCleared) return
      const {width, height} = this.context.canvas
      const {data, data: {length}} = this.context.getImageData(0, 0, width, height)
      const total = length / this.percentageStride
      let clearedCount = 0
      for (let i = clearedCount; i < length; i += this.percentageStride) {
        if (parseInt(data[i], 10) === 0) clearedCount += 1
      }
      this.$emit('percentage-update', Math.round((clearedCount / total) * 100))

      const cleared_area = Math.round((clearedCount / total) * 100)
      if (cleared_area > 50) {
        this.clearArea()
      }

    }
  }
}
</script>

<style lang="scss">
.loading-block {
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vue-scratchable-wrapper {
  position: static;
  width: 100%;
}

.vue-scratchable-wrapper > * {
  user-select: none;
}

canvas {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.congrats h2 strong {
  text-transform: uppercase;
  font-weight: bold;
  font-size:21px;
}
</style>
